import * as React from 'react'
import { ProductAccommodationSelection } from '@modules/product-package/details/products-selection/accommodation-type-selection'
import { ProductsVariantsSelection } from '@modules/product-package/details/products-selection/product-variant/product-variants-selection'
import { EndlessHolidayDetails } from '@modules/product-package/models'
import { useFormContext, useWatch } from 'react-hook-form'
import { EndlessHolidayFormInputs } from '@modules/product-package/details'
import { formatPrice } from '@helpers/price-helper'

interface Props {
  productDetails: EndlessHolidayDetails
}

export const EndlessHolidayDetailsProductsSelection = ({ productDetails }: Props): React.ReactNode => {
  const { control, setValue } = useFormContext<EndlessHolidayFormInputs>()
  const selected = useWatch({ control, name: 'products' })
  const fixedProducts = productDetails.product_package_set.products.filter(product => product.codes_per_package)

  if (fixedProducts.length) {
    return (
      <fieldset className="mt-4">
        <legend>Wybierz wariant pakietu</legend>
        {fixedProducts.map(product => (
          <label key={product.id} className="d-block my-3">
            <input
              type="radio"
              required
              name="fixed-package"
              className="me-2"
              checked={selected[0]?.product.id === product.id}
              onChange={() => setValue('products', [{ product, amount: 1, related_product: null, options: [] }])}
            />
            {product.name} — {product.codes_per_package} kodów, {formatPrice(product.price_brutto)}
          </label>
        ))}
      </fieldset>
    )
  }

  return (
    <div className="mt-4">
      <ProductAccommodationSelection />
      <ProductsVariantsSelection productDetails={productDetails} />
    </div>
  )
}
